import { css } from "@emotion/css";

export const styles = {
  content: css({
    padding: "30px 60px 30px 60px",
  }),
  layout: css({
    minHeight: "100vh",
  }),
};
